import React, { Component } from "react";
import { Col, Container, Modal, ModalBody, Row } from "reactstrap";
import NavTab from "../../../components/common/global_layout/navTab";
import Rating from "../../../components/common/rating";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faSuitcase, faPlane, faHotel, faMugHot
} from "@fortawesome/free-solid-svg-icons";
import httpClient from "../../../httpClient";
import { Button, Comment, Form, Header } from "semantic-ui-react";
import "semantic-ui-css/semantic.min.css";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import FromToDate from "../../../components/common/Cars/fromToDate";
import PagePath from "../../../components/common/pagePath";
import Gallery from "../../../components/common/gellery";
import shared from "../../../shared";
import { announceId, authorId, textComment } from "../../../slices/commentSlice";
import { reserve } from "../../../slices/modalSlice";
import CommentsVoyage from "./commentsVoyage";
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';

class DetailsGhurfaty extends Component {
  constructor(props) {
    super(props);
    const AnnounceId = this.props.match.params.id_voyage;
    this.state = {
      AnnounceId: AnnounceId,
      detailHebergement: [],
      initialComments: [],
      equipement: [],
      commentAthors: [],
      comment: {
        text: "",
        rating: this.props.rating || 4,
        announce: AnnounceId,
        author: this.props.currentUser._id,
      },
      showAlldesciption: false,
      ratingModal: false,
      images: [],
      galleryId: "",
      nbrImages: 0
    };
  }

  componentDidMount() {
    this.getAnnounceDetail();
  }

  getAnnounceDetail() {
    return httpClient
      .getVoyageDetail(this.state.AnnounceId)
      .then((res) => {
        alert("done")
        alert(res)
      });
  }

  submitComment(e) {
    e.preventDefault();
    this.setState({
      ratingModal: true,
    });
    this.props.dispatch(textComment(this.state.comment.text))
    this.props.dispatch(announceId(this.state.comment.announce))
    this.props.dispatch(authorId(this.props.currentUser._id))
    const cmnt = this.state.comment;
    this.setState({
      comment: {
        ...this.state.comment,
        text: "",
      },
    });

  }

  onInputChange(evt) {
    this.setState({
      comment: {
        ...this.state.comment,
        text: evt.target.value,
      },
    });
  }

  toogleRatingClose() {
    this.setState({
      ratingModal: false,
    });
    httpClient.postCommentAccommodation(this.props.comment).then((res) => {
      if (res.success === false) {
        this.props.dispatch({ type: "LOGIN_FORM" });
      } else {
        this.getAnnounceDetail();
      }
    });
  }

  reserveForm = () => {
    this.props.dispatch(reserve());
  };

  getOptions(opt) {
    return shared.getOptions(opt);
  }
  showMore = () => this.setState({ showAlldesciption: true });
  showLess = () => this.setState({ showAlldesciption: false });
  descriptionshow = (content, limit) => {
    if (content.length <= limit) {
      // there is nothing more to show
      return <div>{content}</div>
    }
    if (this.state.showAlldesciption) {
      // We show the extended text and a link to reduce it
      return (<div>
        {content}
        <br />
        <a className="color-gh h1" onClick={this.showLess}>...</a>
      </div>)
    }
    // In the final case, we show a text with ellipsis and a `Read more` button
    const toShow = content.substring(0, limit) + " ....";
    return <div>
      {toShow}
      <br />
      <a className="color-gh h1" onClick={this.showMore}>...</a>
    </div>
  }
  render() {

    const contentD = "Lorem ipsum, dolor sit amet consectetur adipisicing elit. Suscipit nemo, aut obcaecati perferendis rerum dolor eos laboriosam quas maxime quidem perspiciatis voluptatibus voluptas deleniti, reprehenderit recusandae animi inventore. Quaerat, reiciendis. Lorem ipsum, dolor sit amet consectetur adipisicing elit. Suscipit nemo, aut obcaecati perferendis rerum dolor eos laboriosam quas maxime quidem perspiciatis voluptatibus voluptas deleniti, reprehenderit recusandae animi inventore. Quaerat, reiciendis."
    let descriptionF = this.descriptionshow(contentD, 250)




    const {
      title,
      pays,
      region,
      commune,
      nbrRoom,
      nbrAdulte,
      nbrChildren,
      description,
      rating
    } = this.state.detailHebergement;
    return (
      <>
        <NavTab display="none" />
        <PagePath pages={["Ghurfaty", "Voyage", title]} />
        <Container>
          <button className="type-heberg">
            <FontAwesomeIcon className="mx-2" icon={faSuitcase} />
            Voyage
          </button>
          <Row>
            <Col md="7">
              <div className="test">
                <Row className="d-flex justify-content-between align-items-center pl-3 mb-3">
                  <div className="d-flex flex-column">
                    <h2 id="Detail-title">
                      Voyage organise a dubai premiere ligne et deuxieme ligne : 4 jours et 3 nuit
                    </h2>
                    <div className="box-voyage ">
                      <div className="head">
                        <img className="m-2" src="/imgs/voyageIcons/arrow-circle-up-right.svg" alt="" />
                        {/* <FontAwesomeIcon icon={faArrowCircleRight} /> */}
                        départ
                      </div>
                      <div className="content pl-4">
                        Lorem ipsum, dolor sit amet consectetur adipisicing elit. Quasi, ab explicabo fuga dolorum quia expedita officiis console.error();
                      </div>
                    </div>
                    <div className="box-voyage ">
                      <div className="head">
                        <img className="m-2" src="/imgs/voyageIcons/arrow-circle-down-left.svg" alt="" />
                        {/* <FontAwesomeIcon icon={faArrowCircleLeft} /> */}
                        Retour
                      </div>
                      <div className="content pl-4">
                        Lorem ipsum, dolor sit amet consectetur adipisicing elit. Quasi, ab explicabo fuga dolorum quia expedita officiis console.error();
                      </div>
                    </div>
                  </div>
                </Row>

                <hr />

                {/* details voyage */}
                <Row className="icons-details d-flex mb-4">

                  <div className="col-4 d-flex h5">
                    <FontAwesomeIcon className="color-gh mx-2 my-auto" icon={faPlane} />
                    <div className="my-auto">  Par avion
                    </div>
                  </div>
                  <div className="col-4 d-flex h5">
                    <FontAwesomeIcon className="color-gh mx-2 my-auto" icon={faHotel} />
                    <div className="my-auto">
                      Hebergement en Hotel
                    </div>
                  </div>
                  <div className="col-4 d-flex h5">
                    <FontAwesomeIcon className="color-gh  mx-2 my-auto" icon={faMugHot} />
                    <div className="my-auto" >
                      petit-dej inclus
                    </div>
                  </div>
                </Row>

                <hr />

                {/* description voyage */}
                <div >
                  <p className="desc-paragraph text-center h4">
                    {descriptionF}
                  </p>
                </div>

                <hr />

                <div className="row d-flex p-3">
                  <img src="/imgs/profilePic/profile.png" className="ProfilPicVoyage col-3" alt="" />
                  <div className="h2 col-6 align-self-center font-weight-bold"> mahfoud la rome
                    <img style={{ width: "15%" }} className=" pl-2" src="/imgs/voyageIcons/check-decagram.svg" alt="" />
                  </div>
                  <div className="col-3 align-self-center  p-0">
                    <div className="abbonerVoyage btn">
                      <a > Abonner
                        <img className=" pl-2" src="/imgs/voyageIcons/notification.svg" alt="" />
                      </a>
                    </div>
                    <div className=" bg-gh messageVoyage btn text-white mt-2 "  >
                      <a > Message
                        <img className=" pl-2" src="/imgs/voyageIcons/message.svg" alt="" />
                      </a>
                    </div>
                  </div>
                </div>
                <hr />

                {/* comments  */}

                <CommentsVoyage />
              </div>


            </Col>
            <Col md="4" style={{ left: "60px", top: "-50px" }}>
              <div className="carPhotos respo-block">
                <Gallery
                  nbrImages={this.state.nbrImages}
                  img={`${this.state.hostName}/api/announces/${this.state.galleryId}/avatar/0`}
                  galleryId={this.state.galleryId}
                />
              </div>
              <div className="mt-3">
                <Row>
                  <Col className=" border">
                    <div className="p-2">
                      <button className="btn p-0">
                        <img src="/imgs/dash/Minus.svg" style={{ width: "25px" }} alt="" />
                      </button>
                      <span className="color-gh h5"> 02 </span>
                      <button className="btn p-0">
                        <img src="/imgs/dash/Plus.svg" style={{ width: "25px" }} alt="" />
                      </button>
                      <span className="h5 pl-3"> Chambre(s) </span>
                    </div>
                    <fieldset >
                      <legend>Chambre I</legend>
                      <div>
                        <ToggleButtonGroup
                          color="primary"
                          // value={chambre_type}
                          exclusive
                          // onChange={handleChangeChambre}
                        >
                          <ToggleButton value="Single" className="mr-2 border">Single</ToggleButton>
                          <ToggleButton value="Double" className="mx-1 border">Double</ToggleButton>
                          <ToggleButton value="suite" className="ml-2 border">suite</ToggleButton>
                        </ToggleButtonGroup>
                      </div>
                    </fieldset>
                  </Col>
                </Row>
                <Row>
                  <Col className="p-0">
                    <Button className="reserver" onClick={this.reserveForm}>
                      Réserver maintenant
                      <img
                        src="/imgs/resrervationIcons/reserverMaintenant.svg"
                        alt=""
                        className="notifHear-iconOr icon-cnt-fr"
                      />
                    </Button>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>


        </Container>

      </>
    );
  }
}

function mapStateToProps(state) {
  return {
    comment: state.comment
  };
}

//connect function INJECTS dispatch function as a prop!!
export default withRouter(connect(mapStateToProps)(DetailsGhurfaty));
